import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './ProfilePage.css';

const ProfilePage = () => {
  const [userInfo, setUserInfo] = useState({
    name: '张先生',
    phone: '138****8888',
    address: '北京市朝阳区xxx小区xxx号',
    avatar: '👤'
  });

  const [orders] = useState([
    {
      id: 1,
      serviceName: '深度清洁',
      date: '2024-01-15',
      time: '09:00-12:00',
      status: 'completed',
      price: 128
    },
    {
      id: 2,
      serviceName: '日常保洁',
      date: '2024-01-20',
      time: '13:00-16:00',
      status: 'pending',
      price: 88
    }
  ]);

  const getStatusText = (status) => {
    switch (status) {
      case 'pending': return '待服务';
      case 'completed': return '已完成';
      case 'cancelled': return '已取消';
      default: return '未知';
    }
  };

  const getStatusClass = (status) => {
    switch (status) {
      case 'pending': return 'status-pending';
      case 'completed': return 'status-completed';
      case 'cancelled': return 'status-cancelled';
      default: return '';
    }
  };

  return (
    <div className="profile-page">
      <header className="profile-header">
        <Link to="/" className="back-btn">← 返回</Link>
        <h1>个人中心</h1>
      </header>

      <div className="container">
        <div className="user-info-card">
          <div className="user-avatar">{userInfo.avatar}</div>
          <div className="user-details">
            <h2>{userInfo.name}</h2>
            <p>{userInfo.phone}</p>
            <p>{userInfo.address}</p>
          </div>
          <button className="edit-btn">编辑</button>
        </div>

        <div className="menu-section">
          <h3>我的服务</h3>
          <div className="menu-list">
            <div className="menu-item">
              <span>我的预约</span>
              <span className="arrow">›</span>
            </div>
            <div className="menu-item">
              <span>服务评价</span>
              <span className="arrow">›</span>
            </div>
            <div className="menu-item">
              <span>收藏夹</span>
              <span className="arrow">›</span>
            </div>
          </div>
        </div>

        <div className="orders-section">
          <h3>最近订单</h3>
          <div className="orders-list">
            {orders.map(order => (
              <div key={order.id} className="order-item">
                <div className="order-info">
                  <h4>{order.serviceName}</h4>
                  <p>{order.date} {order.time}</p>
                  <p className="order-price">¥{order.price}</p>
                </div>
                <div className={`order-status ${getStatusClass(order.status)}`}>
                  {getStatusText(order.status)}
                </div>
              </div>
            ))}
          </div>
          <Link to="/orders" className="view-all-orders">
            查看全部订单 ›
          </Link>
        </div>

        <div className="menu-section">
          <h3>设置</h3>
          <div className="menu-list">
            <div className="menu-item">
              <span>消息通知</span>
              <span className="arrow">›</span>
            </div>
            <div className="menu-item">
              <span>隐私设置</span>
              <span className="arrow">›</span>
            </div>
            <div className="menu-item">
              <span>关于我们</span>
              <span className="arrow">›</span>
            </div>
            <div className="menu-item">
              <span>联系客服</span>
              <span className="arrow">›</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
